import { useCallback, useEffect } from "react";

import { Dispatch } from "../StateManager/state";
import { Scale, Size } from "./types";

type Props = Readonly<{
  dispatch: Dispatch;
  onSave: () => void;
  scale: Scale,
  size: Size;
}>;
export const KeyboardHandler = ({ dispatch, onSave, scale, size }: Props) => {

  const onKeyDown = useCallback(
    (e: KeyboardEvent) => {
      const key = e.key.toLowerCase();
      const { ctrlKey, keyCode, shiftKey } = e;
      // Let the user type in stuff
      if (e.target.tagName === 'INPUT') {
        return;
      }
      if (key === "s" && ctrlKey) {
        e.preventDefault();
        onSave();
        return;
      }
      dispatch({
        ctrlKey,
        key,
        keyCode,
        onSave,
        preventDefault: () => {
          e.preventDefault();
        },
        shiftKey,
        size: { height: size.height / scale.y, width: size.width / scale.x },
        type: "KEY PRESSED",
      });
    },
    [dispatch, onSave],
  );

  useEffect(() => {
    window.addEventListener("keydown", onKeyDown);
    return () => {
      window.removeEventListener("keydown", onKeyDown);
    };
  }, [onKeyDown]);

  return null;
};
